export default __webpack_public_path__ + "static/media/LogoInvoice.0cd8f7d9.svg";